import { createFileRoute } from '@tanstack/react-router';

import { requireOwnerOrAdmin } from '~/lib/route-auth';
import { AgentControlComponent } from '~/page-components/agent-control';

export const Route = createFileRoute('/settings/agent')({
  beforeLoad: async () => {
    await requireOwnerOrAdmin('/settings');
  },
  component: AgentControlComponent
});
